import type { BridgeService } from './types';

let bridgeRef: BridgeService | null = null;

/**
 * Called from `bridge/index` after `Bridge` is constructed. Avoids a static import cycle:
 * index → ModernBridge → store → modules that call `getBridge()` → index.
 */
export const setBridgeRef = (bridge: BridgeService): void => {
  bridgeRef = bridge;
};

/**
 * Access the live `Bridge` singleton after app bootstrap (store actions, API layer).
 */
export const getBridge = (): BridgeService => {
  if (!bridgeRef) {
    throw new Error('getBridge() called before Bridge is initialized');
  }
  return bridgeRef;
};
